import type { ReactNode } from 'react';
import { Inbox } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ title, description, icon, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-12 rounded-lg border border-dashed border-neutral-200 bg-neutral-50 p-32 text-center',
        className,
      )}
    >
      <div className="text-neutral-400">
        {icon ?? <Inbox className="h-40 w-40" aria-hidden="true" />}
      </div>
      <div className="flex flex-col gap-4">
        <h3 className="text-lg font-semibold text-neutral-800">{title}</h3>
        {description && <p className="max-w-md text-sm text-neutral-600">{description}</p>}
      </div>
      {action}
    </div>
  );
}
